module.exports = __webpack_public_path__ + "img/sex-and-libido.b8b83e2f.svg";